// TR locale formatlama yardımcıları.

const TL = new Intl.NumberFormat("tr-TR", {
  style: "currency",
  currency: "TRY",
  maximumFractionDigits: 2,
});

const TL_SHORT = new Intl.NumberFormat("tr-TR", {
  notation: "compact",
  maximumFractionDigits: 1,
});

const PCT = new Intl.NumberFormat("tr-TR", {
  style: "percent",
  signDisplay: "exceptZero",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const NUM = new Intl.NumberFormat("tr-TR", {
  maximumFractionDigits: 2,
});

const DATE_TIME = new Intl.DateTimeFormat("tr-TR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

export function fmtTL(n: number | null | undefined, opts: { short?: boolean } = {}): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return "—";
  if (opts.short) return `${TL_SHORT.format(n)} TL`;
  return TL.format(n);
}

export function fmtPct(n: number | null | undefined): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return "—";
  return PCT.format(n);
}

export function fmtNum(n: number | null | undefined): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return "—";
  return NUM.format(n);
}

export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return DATE_TIME.format(d);
}

/**
 * "İnsan dili" TL kısaltması — anneye/Gökhan'a okunaklı yuvarlak rakam.
 * Intl.NumberFormat({ notation: "compact" }) TR locale'da "B" / "Mn" çıkartır
 * — "B" bin için ama belirsiz; bunun yerine açık "bin TL" / "milyon TL".
 *
 *   74_213    → "74 bin TL"
 *   248_629   → "249 bin TL"
 *   8_456_000 → "8,5 milyon TL"
 *   920       → "920 TL"
 *   null      → "— TL"
 */
export function fmtTLCompact(n: number | null | undefined): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return "— TL";
  const a = Math.abs(n);
  const sign = n < 0 ? "−" : "";
  if (a >= 1_000_000) {
    const v = (a / 1_000_000).toFixed(1).replace(".", ",");
    return `${sign}${v} milyon TL`;
  }
  if (a >= 1_000) {
    const v = Math.round(a / 1_000);
    return `${sign}${v.toLocaleString("tr-TR")} bin TL`;
  }
  return `${sign}${Math.round(a).toLocaleString("tr-TR")} TL`;
}
